module.exports = __webpack_public_path__ + "static/media/faisal.6321ef98.png";